<template>
  <div>
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition" :loading="loading">
      <v-card>
        <v-toolbar dense dark color="#38383D" height="30" :loading="loading">
          <v-btn x-small icon dark @click="dialog = false">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title class="text-caption">Preview</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn x-small dark @click="savePDF()">
            <v-icon small class="pr-3">save</v-icon> {{pdfFileName}}
          </v-btn>
        </v-toolbar>
        <div id="pdfPreview"></div>
      </v-card>
    </v-dialog>
  </div>
</template>
  
  <script>
  import JsPdf from 'jspdf'
  import PDFObject from 'pdfobject'
  
  // import prServ from '@/store/api/services/prService'
  import prServ from '@/store/api/services/taimemberService'
  import Api from '@/services/Api'
  
  export default {
    // extends: Itisopdf,
    data() {
      return {
        publicPath: process.env.BASE_URL,
        pdfviewerURL: process.env.BASE_URL + "pdf.js/web/viewer.html",
        apiPath: process.env.VUE_APP_API_PATH.replace('//localhost', window.location.protocol + '//' + window.location.host.split(':')[0]),
        pdfdocument: null,
        pdfFileName: '',
        dialog: false,
        loading: false,
        pdfdata_local: {},
        gap_left: 0,
        page_margin_left: 10,
        page_margin_right: 10,
        page_margin_top: 5,
        page_margin_bottom: 5,
        cLine: 0,
        pageTitle: 'ใบสมัครสมาชิก​ สถาบันยานยนต์​ (สำหรับนิติบุคคล)',
        // DocType3Items: ['ตามแผนลงทุนประจำปีรายการที่...', 'ขอใช้เงินเหลือจ่ายรายการที่...', 'เปลี่ยนแปลงจากรายการที่...', 'แผนคืนทุนกรณีมูลค่าทรัพย์สินเกิน 100,000 บาท'],
        // DocType4Items: ['เครื่องจักร/เครื่องมือ', 'เฟอร์นิเจอร์', 'เครื่องใช้สำนักงาน', 'คอมพิวเตอร์/อุปกรณ์งาน IT', 'อุปกรณ์หอพัก', 'ต่อเติม/ปรับปรุงสิ่งก่อสร้าง', 'ซอฟต์แวร์ใช้เกิน 1 ปี', 'อุปกรณ์อื่นๆ'],
        dataPrint: {
          ty: 0
        },
        tableHeaderHeight: 7,
        hTable: [{
            name: 'List',
            type: 'n0',
            width: 8,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'ลำดับ'
          },
          {
            name: 'Item',
            type: 't',
            width: 47,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'รายการ'
          },
          {
            name: 'itemSpac',
            type: 't',
            width: 30,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'คุณลักษณะ'
          },
          {
            name: 'Qty',
            type: 'Qty',
            width: 15,
            alignH: 'center',
            alignD: 'right',
            fontSize: 12,
            caption: 'จำนวน'
          },
          {
            name: 'Total',
            type: 'n2',
            width: 20,
            alignH: 'center',
            alignD: 'right',
            fontSize: 12,
            caption: 'ราคาประมาณ'
          },
          {
            name: 'itemNeedDate',
            type: 'd',
            width: 18,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'วันที่ต้องการ'
          },
          {
            name: 'currentStatus',
            type: 't',
            width: 20,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'สถานะปัจจุบัน'
          },
          {
            name: 'AccountCode',
            type: 'AccountCode',
            width: 16,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'รหัสบัญชี'
          }
        ],
        hTableAsset: [{
            name: 'List',
            type: 'n0',
            width: 8,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'ลำดับ'
          },
          {
            name: 'Item',
            type: 't',
            width: 47,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'รายการ'
          },
          {
            name: 'AssetObjective',
            type: 't',
            width: 30,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'วัตถุประสงค์'
          },
          {
            name: 'Qty',
            type: 'Qty',
            width: 15,
            alignH: 'center',
            alignD: 'right',
            fontSize: 12,
            caption: 'จำนวน'
          },
          {
            name: 'Total',
            type: 'n2',
            width: 20,
            alignH: 'center',
            alignD: 'right',
            fontSize: 12,
            caption: 'ราคาประมาณ'
          },
          {
            name: 'itemNeedDate',
            type: 'd',
            width: 18,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'วันที่ต้องการ'
          },
          {
            name: 'currentStatus',
            type: 't',
            width: 20,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'สถานะปัจจุบัน'
          },
          {
            name: 'AccountCode',
            type: 'AccountCode',
            width: 16,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'รหัสบัญชี'
          }
        ],
        hTableEmp: [{
            name: 'List',
            type: 'n0',
            width: 8,
            alignH: 'center',
            alignD: 'center',
            fontSize: 12,
            caption: 'ลำดับ'
          },
          {
            name: 'EmpCode',
            type: 't',
            width: 54,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'ผู้รับผิดชอบ'
          },
          {
            name: 'rem_use',
            type: 't',
            width: 56,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'คุณลักษณะ'
          },
          {
            name: 'rem_request',
            type: 't',
            width: 56,
            alignH: 'center',
            alignD: 'left',
            fontSize: 12,
            caption: 'เหตุผลในการขอซื้อ'
          },
  
        ]
      }
    },
    props: {
      title: {
        type: String,
        default: ''
      },
      sign01: {
        type: String,
        default: ''
      },
      sign02: {
        type: String,
        default: ''
      },
      sign03: {
        type: String,
        default: ''
      },
      test: {
        type: Object,
        default: function () {
          return {
            d1: [],
            d2: ''
          }
        }
      },
      labels: {
        type: Array,
        default: function () {
          return ['รอดำเนินการ', 'ระหว่างดำเนินการ']
        }
      },
      Color: {
        type: Array,
        default: function () {
          return ['#90CAF9', '#FFCDD2']
        }
      },
      chartdata: {
        type: Object,
        default: function () {
          return {
            dataArray: [0, 0]
          }
        }
      },
      pdfdata: {
        type: Object,
        default: function () {
          return {}
        }
      }
    },
    watch: {
      chartdata() {
        // console.log('watch data', this.chartdata)
        if (this.chartdata !== '') {
          // this.dataArray = this.chartdata.split(',')
          this.showChart(this.chartdata, this.labels, this.Color)
        }
      },
      pdfdata() {
        // console.log('watch pdfdata', this.pdfdata)
      },
      title() {
        // console.log('watch title', this.title)
      }
    },
    mounted() {
      // if (this.chartdata !== '') {
      // this.dataArray = this.chartdata.split(',')
      // this.showChart(this.chartdata, this.labels, this.Color)
      // }
      // Overwriting base render method with actual data.
      // bookServ.dashboard({empCode: this.$store.state.users.main.empCode})
      //   .then(response => {
      //     // console.log(this.labels)
      //     this.showChart([response.data.data[0].Wait, response.data.data[0].Process], this.labels, this.Color)
      //   })
    },
    computed: {
      empAll: function () {
        if (localStorage.getItem('EmpAll')) {
          return JSON.parse(localStorage.getItem('EmpAll'))
        }
        localStorage.setItem(
          'EmpAll',
          JSON.stringify(this.$store.state.users.empAll)
        )
        return this.$store.state.users.empAll
      },
      allDep: function () {
        return this.$store.state.users.dep
      },
      pLeft: function () {
        return this.page_margin_left + this.gap_left
      },
      pRight: function () {
        return 210 - this.page_margin_right
      },
      pCenter: function () {
        return (this.pRight - this.pLeft) / 2 + this.pLeft
      },
      pWidth: function () {
        return this.pRight - this.pLeft
      },
      pHeight: function () {
        return this.pBottom - this.pTop
      },
      pTop: function () {
        return this.page_margin_top
      },
      pBottom: function () {
        return 298 - this.page_margin_bottom
      }
    },
    methods: {
      setFontStyle(doc, fontStyle) {
        let objFont = doc.getFont()
        console.log('objFont' , objFont)
        doc.setFont(objFont.fontName, fontStyle)
  
      },
      async getDB(ID) {
        // let id = this.pdfdata_local.id
        // prService.prdochdItemByID()
        let key = {
          pageNo: 1,
          rowsPerPage: 999,
          sortBy: 'List',
          descending: '',
          search: '',
          filter: '',
          ID: ID
        }
        // console.log('created', this.$route.params.id)
        // this.loading = true
        let responseHD = await prServ.prdochdItemByID(key)
        let responseDT = await prServ.prdocdtListByParam(key)
        // a.then((response) => {
        let DBdata = responseHD.data.data[0]
        DBdata.DTdata = responseDT.data.data
        // })
        // .catch((error) => {
        //   console.error(error)
        // })
        // this.loading = false
        return DBdata
      },
      empObj: function (empCode) {
        if (localStorage.getItem('EmpAll') !== '') {
          return JSON.parse(localStorage.getItem('EmpAll')).find(
            (el) => el.EmpCode === empCode
          )
        }
        return this.$store.state.users.persons.find(
          (el) => el.EmpCode === empCode
        )
      },
      dateDisplay: function (dateDB) {
        if (typeof dateDB === 'string') {
          // console.log('dateDB', dateDB)
          if (dateDB !== dateDB.replace('T', '')) {
            dateDB = dateDB.split('T')[0]
          }
          var dateDBnew = new Date(dateDB)
          if (!isNaN(dateDBnew.getTime())) {
            return (
              dateDBnew.getDate() +
              '/' +
              (dateDBnew.getMonth() + 1) +
              '/' +
              (dateDBnew.getFullYear() + 543)
            )
          }
        }
        return '........../........../..........'
      },
      wTable(doc) {
        doc.autoTable({
          styles: {
            font: 'THSarabunNew',
            fontSize: 14,
            fontStyle: 'normal'
          },
          // columnStyles: {0: {halign: 'center', fillColor: [0, 255, 0]} , 3:{columnWidth:50}}, // Cells in first column centered and green
          columnStyles: {
            3: {
              columnWidth: 50
            }
          }, // Cells in first column centered and green
          head: [
            ['Name', 'Email', 'Country', 'REM']
          ],
          didDrawPage: (data) => {
            // console.log(data)
            doc.page = data.pageNumber
            // console.log(doc.page)
            // footer(doc)
            // doc.setFont('THSarabunNew')
            // doc.addImage(img, 'png', 160, 10, 40, 22)
            // doc.text(200,285, 'page ' + doc.page , null , null , 'right'); //print number bottom right
            // doc.page ++;
          },
          margin: {
            bottom: 20,
            top: 50
          },
          body: [
            ['David', 'david@example.com', 'Sweden', 'สถาบันยานยนต์'],
            [
              'Castille',
              'castille@example.com',
              'Norway',
              'ปสถาบันยานยนต์สถาบันยานยนต์สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์'
            ],
            [
              'Castille',
              'castille@example.com',
              'Norway',
              ' สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์ สถาบันยานยนต์'
            ]
          ]
        })
      },
      wSign01(doc) {
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.1)
        doc.line(25, 265, 85, 265, 'S')
  
        var img = new Image()
        if (this.sign01 !== '' && this.sign01 !== undefined) {
          img.src = this.sign01
          // console.log('wSign01 this.sign01', img)
          try {
            doc.addImage(img, 'png', 35, 248, 40, 20)
          } catch (e) {
            // console.log('sign emp not found')
          }
        }
        this.setFontStyle(doc, 'normal')
        doc.setFontSize(14)
        // doc.text('suppakorn105dafasdfa', 105, 270, null, null, 'center')
        var emp = this.empObj(this.pdfdata_local.S4_EmpCode)
        // console.log('sign01', emp)
        doc.text('ผู้ตรวจรับงาน', 15, 240, null, null, 'left')
        if (emp) {
          doc.text('(' + emp.EmpName + ')', 55, 270, null, null, 'center')
        } else {
          doc.text(
            '(...................................)',
            55,
            270,
            null,
            null,
            'center'
          )
        }
        doc.text(
          this.dateDisplay(this.pdfdata_local.S4_EmpDate),
          55,
          275,
          null,
          null,
          'center'
        )
      },
      wLine(doc) {
        // sing01
        doc.setDrawColor(0, 0, 0)
        doc.setLineWidth(0.5)
        doc.rect(
          10,
          20,
          doc.internal.pageSize.width - 20,
          doc.internal.pageSize.height - 30,
          'S'
        )
        doc.line(10, 230, 200, 230, 'S')
        doc.line(105, 230, 105, 287, 'S')
  
        // console.log('doc.internal.pageSize.width', doc.internal.pageSize.width)
        // console.log('doc.internal.pageSize.height', doc.internal.pageSize.height)
      },
      nextLine(doc, height, cutHeight = 0) {
        // doc.setTextColor('#ff0000')
        // this.setText(doc, this.cLine.toString(), this.pRight, this.cLine, 'right')
        // doc.setTextColor('#000000')
        let temp_FontSize = doc.getFontSize()
        if (this.cLine + cutHeight > this.pBottom) {
          doc.addPage('a4', 'p')
          this.cPage++
          this.countPage++
          this.cLine = this.pTop
          this.wHeader(doc)
          this.nextLine(doc, 7)
          doc.setFontSize(temp_FontSize)
          return true
        } else {
          this.cLine += height
          return false
        }
      },
      wHD01(doc, tStart) {
        doc.setFontSize(14)
        this.setFontStyle(doc,'normal')
        this.cLine = tStart
  
        this.nextLine(doc, 6)
        doc.setFontSize(14)
        this.setFontStyle(doc, 'bold')
        this.setText(
          doc,
          'ส่วนที่ 1 (ผู้ขอซื้อ ขอจ้าง)',
          this.pLeft,
          this.cLine,
          'left'
        )
  
        this.setFontStyle(doc, 'normal')
        this.setText(
          doc,
          'วันที่ ...................................................',
          this.pRight,
          this.cLine,
          'right'
        )
        doc.setFontSize(16)
        this.setFontStyle(doc, 'bold')
        this.setDBText(
          doc,
          this.$options.filters.date(this.pdfdata_local.DocDate),
          170,
          this.cLine - 0.5,
          'center'
        )
  
        doc.setFontSize(14)
        this.setFontStyle(doc, 'normal')
        this.nextLine(doc, 6)
        this.setText(
          doc,
          'รหัสโครงการ ...................................................',
          this.pRight,
          this.cLine,
          'right'
        )
        doc.setFontSize(16)
        this.setDBText(
          doc,
          this.accountCodeFilter(this.pdfdata_local.AccountCode),
          170,
          this.cLine - 0.5,
          'center'
        )
        doc.setFontSize(14)
        this.setFontStyle(doc, 'normal')
        this.nextLine(doc, 6)
        this.setText(
          doc,
          'วันที่ต้องการ ...................................................',
          this.pRight,
          this.cLine,
          'right'
        )
        doc.setFontSize(16)
        this.setFontStyle(doc, 'bold')
        this.setDBText(
          doc,
          this.$options.filters.date(this.pdfdata_local.needDate),
          170,
          this.cLine - 0.5,
          'center'
        )
  
        this.nextLine(doc, 6)
        let pp = this.setText(doc, 'เรื่อง', this.pLeft, this.cLine, 'left')
        this.setLine(doc, pp.x, this.cLine, 0, this.pRight) //this.pCenter)
        doc.setFontSize(14)
  
        let splitCaption = doc.splitTextToSize(this.pdfdata_local.topic, this.pRight - pp.x)
        this.setText(
          doc,
          splitCaption,
          pp.x + 1,
          this.cLine - 0.5
        )
        for (let i = 0; i < splitCaption.length - 1; i++) {
          this.nextLine(doc, 6)
          this.setLine(doc, pp.x, this.cLine, 0, this.pRight)
        }
        // this.setDBText(doc,this.pdfdata_local.topic,pp.x + 5,this.cLine - 0.5,'left')
        // this.setDBText(doc,this.pdfdata_local.topic,pp.x + 5,this.cLine - 0.5,'left')
        doc.setFontSize(14)
      },
      wHD02(doc, tStart) {
        this.cLine = tStart
        let pp = {
          x: this.pLeft
        }
        pp = this.setText(
          doc,
          '[   ] หน่วยงานจัดซื้อเอง',
          this.pLeft,
          this.cLine,
          'left'
        )
        if (this.pdfdata_local.DocType1 === 'หน่วยงานจัดซื้อเอง') {
          this.setTextCheck(doc, this.pLeft, this.cLine)
        }
        if (this.pdfdata_local.DocType1 === 'ยกเลิก') {
          // this.setText(
          //         doc,
          //         'ยกเลิก',
          //         doc.internal.pageSize.getWidth() / 2,
          //         doc.internal.pageSize.getHeight() / 2,
          //         { align: 'center', angle:45}
          //       )
          doc.setTextColor('#ff0000')
          doc.setFontSize(100)
          doc.text('ยกเลิก', (doc.internal.pageSize.getWidth() / 2) + 20, doc.internal.pageSize.getHeight() / 2, {
            align: 'center',
            angle: 45
          });
          doc.setFontSize(14)
          doc.setTextColor('#000000')
        }
  
        pp = this.setText(doc, '[   ] แนบ Specification', 65, this.cLine, 'left')
        // console.log('files01', this.pdfdata_local.files01)
        // console.log('files01 is array', Array.isArray(this.pdfdata_local.files01))
        if (Array.isArray(this.pdfdata_local.files01)) {
          if (this.pdfdata_local.files01.length > 0) {
            this.setTextCheck(doc, 65, this.cLine)
          }
        }
  
        pp = this.setText(
          doc,
          '[   ] ซื้อด่วน เนื่องจาก',
          110,
          this.cLine,
          'left'
        )
        this.setLine(doc, pp.x, this.cLine, 0, this.pRight)
        if (this.pdfdata_local.DocType2 !== 'ซื้อตามขั้นตอนปกติ') {
          this.setTextCheck(doc, 110, this.cLine)
          this.setDBText(doc, this.pdfdata_local.DocType2, pp.x + 2, this.cLine, 'left')
        }
        this.nextLine(doc, 7)
        pp = this.setText(
          doc,
          '[   ] งานจัดซื้อดำเนินการให้',
          this.pLeft,
          this.cLine,
          'left'
        )
        if (this.pdfdata_local.DocType1 === 'งานจัดซื้อดำเนินการให้') {
          this.setTextCheck(doc, this.pLeft, this.cLine)
        }
        pp = this.setText(
          doc,
          '[   ] ซื้อตามขั้นตอนปกติ',
          110,
          this.cLine,
          'left'
        )
        if (this.pdfdata_local.DocType2 === 'ซื้อตามขั้นตอนปกติ') {
          this.setTextCheck(doc, 110, this.cLine)
        }
      },
      wHD02_asset(doc, tStart) {
        if (this.pdfdata_local.DocType1 === 'ยกเลิก') {
          doc.setTextColor('#ff0000')
          doc.setFontSize(100)
          doc.text('ยกเลิก', (doc.internal.pageSize.getWidth() / 2) + 20, doc.internal.pageSize.getHeight() / 2, {
            align: 'center',
            angle: 45
          });
          doc.setFontSize(14)
          doc.setTextColor('#000000')
        }
        this.cLine = tStart
        let xMargin = this.pLeft + doc.getTextWidth('ประเภท ')
        let pp = {
          x: xMargin
        }
        // pp = this.setText(doc,'ประเภท ',this.pLeft,this.cLine,'left')
        let caption = ''
        // this.pdfdata_local.DocType3 = this.pdfdata_local.DocType3 + ','
        for (let i4 = 0; i4 < this.DocType3Items.length; i4++) {
          // console.log( this.DocType3Items[i4] +'|'+this.pdfdata_local.DocType3 +'|'+this.pdfdata_local.DocType3.length, this.pdfdata_local.DocType4.indexOf(this.DocType3Items[i4]))
          caption = this.DocType3Items[i4]
          for (let j4 = 0; j4 < this.pdfdata_local.DocType3.length; j4++) {
            let findstart = this.pdfdata_local.DocType3[j4].indexOf(this.DocType3Items[i4])
            if (findstart >= 0) {
              this.setTextCheck(doc, pp.x, this.cLine)
              caption = this.pdfdata_local.DocType3[j4]
              for (let k4 = 1; k4 < this.pdfdata_local.DocType3.length; k4++) {
                caption += this.pdfdata_local.DocType3[k4]
              }
              console.log('this.pdfdata_local.DocType3[j4]', this.pdfdata_local.DocType3)
              // let findend = this.pdfdata_local.DocType3.indexOf(',',findstart+1)
              // caption = this.pdfdata_local.DocType3.substr(findstart,findend - findstart)
            }
          }
          pp = this.setText(doc, '[   ] ' + caption, pp.x, this.cLine, 'left')
          if (i4 === 2) {
            this.nextLine(doc, 7)
            pp.x = xMargin - 3
          }
          pp.x += 3
        }
        this.nextLine(doc, 7)
        pp = this.setText(doc, 'ประเภท ', this.pLeft, this.cLine, 'left')
  
        for (let i4 = 0; i4 < this.DocType4Items.length; i4++) {
          // console.log( this.DocType4Items[i4] +'|'+this.pdfdata_local.DocType4, this.pdfdata_local.DocType4.indexOf(this.DocType4Items[i4]))
          // for (j4 = 0 ; j4 <= this.DocType3Items.length ;  j4++){
          if (this.pdfdata_local.DocType4.indexOf(this.DocType4Items[i4]) >= 0) {
            this.setTextCheck(doc, pp.x, this.cLine)
          }
          // }
          pp = this.setText(doc, '[   ] ' + this.DocType4Items[i4], pp.x, this.cLine, 'left')
          if (i4 === 3) {
            this.nextLine(doc, 7)
            pp.x = xMargin - 3
          }
          pp.x += 3
        }
      },
      setNormalFont(doc) {
        doc.setFont("THSarabunNew")
        doc.setFontSize(14)
        this.setFontStyle(doc, 'normal')
        doc.setLineDashPattern([], 0)
      },
      setLine(doc, x, y, w, x2 = 0) {
        let mX = 0
        let mY = 0.5
        doc.setLineDashPattern([0.3, 0.3], 0.6)
        doc.setLineWidth(0.2)
        y += mY
        if (x2 === 0) {
          doc.line(x - mX, y, x + w - mX, y, 'S')
        } else {
          doc.line(x - mX, y, x2 - mX, y, 'S')
        }
        doc.setLineDashPattern([], 0)
      },
      setLinNumber(doc) {
        this.setText(doc, ' ' + this.cLine + ' ', this.pLeft - 10, this.cLine, 'right')
      },
      setText: function (doc, t, x, y, s = 'left') {
        let pp = {    // PDF ให้แสดงถ้า โดยเจอค่า null(ค่าว่าง) ให้ข้ามไป field ต่อไปได้
          width: 0    // PDF ให้แสดงถ้า โดยเจอค่า null(ค่าว่าง) ให้ข้ามไป field ต่อไปได้
        }             // PDF ให้แสดงถ้า โดยเจอค่า null(ค่าว่าง) ให้ข้ามไป field ต่อไปได้
        if (t===null) return pp   // PDF ให้แสดงถ้า โดยเจอค่า null(ค่าว่าง) ให้ข้ามไป field ต่อไปได้
        doc.text(t, x, y, null, null, s)
        
        if (Array.isArray(t)) {
          for (let i = 0; i < t.length; i++) {
            if (pp.width < doc.getTextWidth(t[i])) {
              pp.width = doc.getTextWidth(t[i])
            }
          }
        } else {
          pp.width = doc.getTextWidth(t)
        }
        pp.x = x + pp.width
        return pp
      },
      dbtoString(v) {
        if (v == null) {
          return ''
        }
        if (typeof v !== 'string') {
          return v.toString()
        }
        return v
      },
      setDBText: function (doc, v, x, y, s = 'left') {
        let t = this.dbtoString(v)
        this.setFontStyle(doc, 'bold')
        doc.text(t, x, y, null, null, s)
        this.setFontStyle(doc, 'normal')
        let pp = {
          width: 0
        }
        if (Array.isArray(t)) {
          for (let i = 0; i < t.length; i++) {
            if (pp.width < doc.getTextWidth(t[i])) {
              pp.width = doc.getTextWidth(t[i])
            }
          }
        } else {
          pp.width = doc.getTextWidth(t)
        }
        pp.x = x + pp.width
        return pp
      },
      wDetail03_4(doc, ystart) {
        doc.setFontSize(12)
        let tx = this.pLeft
        let lx = 0
        let text = ''
        let pp = {
          x: this.pLeft
        }
        let ctext, ftext, vtext, dtext, rtext, etext
        let padding = 5
        let atext = [{
            fieldName: 'processType',
            value: 'วิธีตกลงราคา',
            caption: '[   ] วิธีตกลงราคา'
          },
          {
            fieldName: 'processType',
            value: 'วิธีสอบราคา',
            caption: '[   ] วิธีสอบราคา'
          },
          {
            fieldName: 'processType',
            value: 'วิธีประกวดราคา',
            caption: '[   ] วิธีประกวดราคา'
          },
          {
            fieldName: 'processType',
            value: 'วิธีพิเศษ',
            caption: '[   ] วิธีพิเศษ'
          }
        ]
        //  "processType": "วิธีตกลงราคา",
  
        this.setFontStyle(doc, 'normal')
        text =
          'จัดซื้อจาก........................................................ จำนวนเงิน ................................... บาท'
        pp = this.setText(doc, text, tx, this.cLine, 'left')
  
        text = this.pdfdata_local['buyWho']
        this.setDBText(doc, text, 55, this.cLine - 0.5, 'center')
        text = this.pdfdata_local['GTotal']
        if (text !== null) {
          text = text.toLocaleString('th-TH', {
            minimumFractionDigits: 2
          })
        }
        this.setDBText(doc, text, 110, this.cLine - 0.5, 'right')
  
        this.nextLine(doc, 6)
  
        pp.x = this.pLeft
        for (let i = 0; i < atext.length; i++) {
          ctext = atext[i].caption
          ftext = atext[i].fieldName
          vtext = ''
          if (ftext === 'processType') {
            vtext = this.pdfdata_local[ftext]
            if (vtext !== null) {
              if (vtext.indexOf(atext[i].value) >= 0) {
                this.setTextCheck(doc, pp.x, this.cLine)
              }
            }
          }
          doc.setFontSize(12)
          pp = this.setText(doc, ctext, pp.x, this.cLine, 'left')
          pp.x += padding
        }
        atext = [{
            fieldName: '04',
            caption: 'เจ้าหน้าที่จัดซื้อ'
          },
          {
            fieldName: '05',
            caption: '  ผู้กลั่นกรอง  '
          },
          {
            fieldName: '06',
            caption: '    ผู้อนุมัติ   '
          }
        ]
        tx = pp.x + padding
        // console.log('atext', atext)
        for (let i = 0; i < atext.length; i++) {
  
          ctext = atext[i].caption
          text =
            '.....................................' +
            ctext +
            '....................................'
          pp = this.setText(doc, text, tx, this.cLine, 'left')
  
          etext = this.pdfdata_local['EmpCode' + atext[i].fieldName]
          vtext = ''
          etext = this.$options.filters.empName(etext, this.empAll, 'คุณ')
          dtext = this.$options.filters.date(
            this.pdfdata_local['EmpDate' + atext[i].fieldName]
          )
          rtext = this.pdfdata_local['EmpRem' + atext[i].fieldName]
          if (etext) {
            pp = this.setText(doc, etext, 138, this.cLine - 0.5, 'center')
          }
          if (dtext) {
            vtext = dtext
          } else {
            vtext = '/       /'
          }
          pp = this.setText(doc, vtext, 180, this.cLine - 0.5, 'center')
          this.nextLine(doc, 6)
  
          // if(rtext) {
          //   vtext += rtext
          // } else {
          //   vtext += '.............................. '
          // }
        }
        // this.nextLine(doc,6)
        // text ='..............................  ผู้กลั่นกลอง    ........../........../............'
        // pp = this.setText(doc,text, tx, this.cLine,'left')
  
        // this.nextLine(doc,6)
        // text ='..............................   ผู้อนุมัติ       ........../........../............'
        // pp = this.setText(doc,text, tx, this.cLine,'left')
  
        return this.cLine
      },
      wDetail03_3(doc, ystart) {
        doc.setFontSize(12)
        let tx = this.pLeft
        let lx = 0
        let text = ''
        let pp = {
          x: this.pLeft
        }
        let padding = 5
        let atext = [{
            fieldName: 'processAppv',
            value: 'ลงนาม PO',
            caption: '[   ] ลงนาม PO'
          },
          {
            fieldName: 'processAppv',
            value: 'ใบยืม-คืนเงินทดรอง',
            caption: '[   ] ใบยืม-คืนเงินทดรอง'
          },
          {
            fieldName: 'processAppv',
            value: 'ใบเบิกเงินสดย่อย',
            caption: '[   ] ใบเบิกเงินสดย่อย'
          },
          {
            fieldName: '',
            value: '',
            caption: '[   ] แนบไฟล์ (PDF)'
          }
        ]
        // "processAppv": "ลงนาม PO,ใบยืม-คืนเงินทดรอง,ใบเบิกเงินสดย่อย",
        this.setFontStyle(doc, 'normal')
        text = 'เพื่อโปรดพิจารณาอนุมัติ และ'
        pp = this.setText(doc, text, tx, this.cLine, 'left')
  
        for (let i = 0; i < atext.length; i++) {
          this.setFontStyle(doc, 'normal')
          let ctext = atext[i].caption
          let ftext = atext[i].fieldName
          let vtext = ''
          if (ftext === 'processAppv') {
            vtext = this.pdfdata_local[ftext]
            if (vtext !== null) {
              if (vtext.indexOf(atext[i].value) >= 0) {
                this.setTextCheck(doc, pp.x + padding, this.cLine)
              }
            }
          }
          pp = this.setText(doc, ctext, pp.x + padding, this.cLine, 'left')
        }
        return this.cLine
      },
      wDetail03_2(doc, ystart) {
        // let this.cLine = ystart + 7
        doc.setFontSize(12)
        let tx = this.pLeft
  
        let text = ''
        let lx = 0
        let pp
        this.setFontStyle(doc, 'normal')
        text = 'ผลการพิจารณากรรมการ/คณะกรรมการจัดซื้อจัดจ้าง'
        pp = this.setText(doc, text, tx, this.cLine, 'left')
        let xstart = pp.x
        text = '  .............................................................  '
        pp = this.setText(doc, text, pp.x, this.cLine, 'left')
        let xcenter = xstart + (pp.x - xstart) / 2
        this.setDBText(
          doc,
          this.pdfdata_local['processRem'],
          xcenter,
          this.cLine - 0.5,
          'center'
        )
        text = '[    ] แนบรายงานพิจารณา'
        pp = this.setText(doc, text, pp.x, this.cLine, 'left')
  
        // lx = doc.getTextWidth(text) + 5
        // tx += lx
        this.cLine += 7
        text =
          '..................................................................... กรรมการ/คณะกรรมการคัดเลือก'
        this.setText(doc, text, this.pRight, this.cLine, 'right')
        text = this.$options.filters.empName(
          this.pdfdata_local['committee_1'],
          this.empAll,
          'คุณ'
        )
        this.setDBText(doc, text, 150, this.cLine - 0.5, 'right')
  
        lx = doc.getTextWidth(text) + 5
        tx += lx
  
        return this.cLine
      },
      wDetail03_1(doc, ystart) {
        // let this.cLine = ystart + 5
        let tx = this.pLeft
        let pp
        doc.setFontSize(14)
        this.setFontStyle(doc, 'bold')
        pp = this.setText(
          doc,
          'ส่วนที่ 3 (หน่วยงานจัดซื้อจัดจ้าง)',
          tx,
          this.cLine,
          'left'
        )
        let text = ''
        let padding = 5
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.setFontSize(12)
        this.setFontStyle(doc, 'normal')
        text = 'การดำเนินการ'
        pp = this.setText(doc, text, tx, this.cLine, 'left')
        // lx = pp.width + 5
        // tx += lx
        // tx =40
  
        text = '[   ] ทำคำสั่ง/ประกาศ'
        pp = this.setText(doc, text, pp.x + padding, this.cLine, 'left')
        // lx = pp.width + 5
        // tx += lx
        // tx =75
  
        text = '[   ] รายงาน/อนุมัติผลคัดเลือก'
        pp = this.setText(doc, text, pp.x + padding, this.cLine, 'left')
        // lx = pp.width + 5
        // tx += lx
        // tx = 115
  
        text = '[   ] รายงาน/อนุมัติผลตรวจรับ'
        pp = this.setText(doc, text, pp.x + padding, this.cLine, 'left')
  
        return this.cLine
      },
      wDetail03_1_asset(doc, ystart) {
        // let this.cLine = ystart + 5
        let tx = this.pLeft
        let pp
        doc.setFontSize(14)
        this.setFontStyle(doc, 'bold')
        pp = this.setText(doc, 'ส่วนที่ 3 (พนักงานจัดซื้อ)', tx, this.cLine, 'left')
        return this.cLine
      },
      wDetail02_2(doc, ystart) {
        let ty = ystart
        let tx = 15
  
        // doc.text('ผู้มีอำนาจ', tx , ty, null, null, 'left')
        return ty
      },
      wDetail02_1(doc, ystart) {
        // let ty = ystart + 7
        let tx = this.pLeft
  
        doc.setFontSize(14)
        this.setFontStyle(doc, 'bold')
        this.setText(doc, 'ส่วนที่ 2 ผู้อนุมัติขอซื้อ/ขอจ้าง', tx, this.cLine, 'left')
        // this.cLine += 5
        this.nextLine(doc, 5)
        doc.setFontSize(12)
        this.setFontStyle(doc, 'normal')
        let pp
        let padding = 5
        let bullet_right = this.pRight - 50
        let bullet_space = (bullet_right - this.pLeft) / 3
        pp = this.setText(doc, '[   ] อนุมัติตามเสนอ', tx, this.cLine, 'left')
        // this.setTextCheck(doc,tx,this.cLine)
        tx += bullet_space
        pp = this.setText(
          doc,
          '[   ] ไม่อนุมัติตามเสนอ',
          pp.x + padding,
          this.cLine,
          'left'
        )
        // this.setTextCheck(doc,tx,this.cLine)
        tx += bullet_space
        pp = this.setText(
          doc,
          '[   ] ส่งพนักงานแก้ไข',
          pp.x + padding,
          this.cLine,
          'left'
        )
        // tx += 60
  
        tx = this.pLeft
  
        for (let i = 0; i < 2; i++) {
          this.cLine += 5
          this.setLine(doc, tx, this.cLine, 0, bullet_right)
        }
  
        // ผู้มีอำนาจ
        tx = 170
        this.cLine -= 10
        this.setLine(doc, tx - 15, this.cLine, 30)
        // this.setLine(doc,tx,this.cLine,30)
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.text('ผู้มีอำนาจ', tx, this.cLine, null, null, 'center')
  
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.text('/          /', tx, this.cLine, null, null, 'center')
        this.setLine(doc, tx - 15, this.cLine, 30)
  
        return this.cLine + 2
      },
      wDetail02_1_asset(doc, ystart) {
        // let ty = ystart + 7
        let tx = this.pLeft
        let bullet_right = this.pRight - 50
  
        doc.setFontSize(12)
        this.setFontStyle(doc, 'bold')
        this.setText(doc, 'ส่วนที่ 2', tx, this.cLine, 'left')
        this.setFontStyle(doc, 'normal')
        this.nextLine(doc, 0)
        this.setText(doc, 'ความเห็น (ผู้กลั่นกรอง)', 80, this.cLine, 'center')
        // this.cLine += 5
        // this.nextLine(doc, 5)
  
        // ผู้กลั่นกรอง ========================================================
        tx = this.pLeft
  
        for (let i = 0; i < 3; i++) {
          this.nextLine(doc, 5)
          this.setLine(doc, tx, this.cLine, 0, bullet_right)
        }
        tx = 170
        // this.cLine -= 10
        this.nextLine(doc, -10)
        this.setLine(doc, tx - 15, this.cLine, 30)
        // this.setLine(doc,tx,this.cLine,30)
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.text('ผู้กลั่นกรอง', tx, this.cLine, null, null, 'center')
  
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.text('/          /', tx, this.cLine, null, null, 'center')
        this.setLine(doc, tx - 15, this.cLine, 30)
        this.nextLine(doc, 6)
        //=================================================================
        this.nextLine(doc, 0)
        this.setText(doc, 'สำหรับผู้อนุมัติ', 80, this.cLine, 'center')
        this.nextLine(doc, 6)
        tx = this.pLeft
        doc.setFontSize(12)
        this.setFontStyle(doc, 'normal')
        let pp
        let padding = 5
  
        let bullet_space = (bullet_right - this.pLeft) / 3
        pp = this.setText(doc, '[   ] อนุมัติตามเสนอ', tx, this.cLine, 'left')
        // this.setTextCheck(doc,tx,this.cLine)
        tx += bullet_space
        pp = this.setText(
          doc,
          '[   ] ไม่อนุมัติตามเสนอ',
          pp.x + padding,
          this.cLine,
          'left'
        )
        // this.setTextCheck(doc,tx,this.cLine)
        tx += bullet_space
        pp = this.setText(
          doc,
          '[   ] ส่งพนักงานแก้ไข',
          pp.x + padding,
          this.cLine,
          'left'
        )
        // tx += 60
  
        tx = this.pLeft
  
        for (let i = 0; i < 2; i++) {
          this.cLine += 5
          this.setLine(doc, tx, this.cLine, 0, bullet_right)
        }
  
        // ผู้มีอำนาจ
        tx = 170
        this.cLine -= 10
        this.setLine(doc, tx - 15, this.cLine, 30)
        // this.setLine(doc,tx,this.cLine,30)
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.text('ผู้มีอำนาจ', tx, this.cLine, null, null, 'center')
  
        // this.cLine += 6
        this.nextLine(doc, 6)
        doc.text('/          /', tx, this.cLine, null, null, 'center')
        this.setLine(doc, tx - 15, this.cLine, 30)
  
        return this.cLine + 2
      },
      wDetail01_2(doc, ystart) {
        // let this.cLine = ystart + 6
  
        let tx = this.pLeft
        let ctext = ''
        let vtext = ''
        let dtext = ''
        let rtext = ''
        let pp = {}
        if (this.pdfdata_local.DocTypeCode.indexOf('PR') === 0) {
          doc.setFontSize(14)
          this.nextLine(doc, 5)
          let text = 'จึงเรียนมาเพื่อโปรดพิจารณาดำเนินการต่อไป'
          this.setText(doc, text, tx, this.cLine, 'left')
        }
        this.setNormalFont(doc)
        doc.setFontSize(12)
        let captionUser = ''
        if (this.pdfdata_local.DocTypeCode.indexOf('PR') === 0) {
          captionUser = 'ผู้ขอซื้อ/ขอจ้าง'
        }
        if (this.pdfdata_local.DocTypeCode.indexOf('AS') === 0) {
          captionUser = 'ผู้ขออนุมัติ'
        }
        let atext = [{
            fieldName: '01',
            caption: captionUser
          },
          {
            fieldName: '02',
            caption: '  ผู้กลั่นกรอง '
          },
          {
            fieldName: '03',
            caption: '   ผู้อนุมัติ  '
          }
        ]
  
        for (let i = 0; i < atext.length; i++) {
          this.nextLine(doc, 5)
          ctext = atext[i].caption
          vtext = this.$options.filters.empName(
            this.pdfdata_local['EmpCode' + atext[i].fieldName],
            this.empAll,
            'คุณ'
          )
          dtext = this.$options.filters.date(
            this.pdfdata_local['EmpDate' + atext[i].fieldName]
          )
          rtext = this.pdfdata_local['EmpRem' + atext[i].fieldName]
          // let splitTitle = doc.splitTextToSize(text, 10);
          this.setFontStyle(doc, 'bold')
          pp = this.setText(doc, vtext, this.pLeft, this.cLine, 'left')
          this.setFontStyle(doc, 'normal')
          tx = 85
          pp = this.setText(doc, ctext, tx, this.cLine, 'center')
          // let lx = doc.getTextWidth(text) + marginText
          this.setLine(doc, this.pLeft, this.cLine, 0, tx - pp.width / 2)
  
          this.setLine(doc, 92, this.cLine, 30)
          if (dtext === '') {
            this.setText(doc, '     /     /     ', 105, this.cLine, 'center')
          } else {
            this.setFontStyle(doc, 'bold')
            this.setText(doc, dtext, 108, this.cLine, 'center')
            this.setFontStyle(doc, 'normal')
          }
  
          let xRemark = 140
          this.setLine(doc, xRemark, this.cLine, 0, this.pRight)
          this.setText(doc, 'หมายเหตุ', xRemark - 5, this.cLine, 'right')
          if (rtext) {
            this.setText(doc, rtext, xRemark, this.cLine, 'left')
          }
        }
        return this.cLine
      },
      wDetail01_1(doc, ystart) {
        this.setNormalFont(doc)
        doc.setFontSize(12)
        // let ty = ystart + 5
        // this.nextLine(5)
        let tx = this.pLeft
        let pp
        let lx = 0
        let marginText = 6
        let ctext = ''
        let vtext = ''
        // this.nextLine(-6)
        let atext = [{
            fieldName: 'QuotationNo',
            caption: 'หมายเลขใบเสนอราคาของลูกค้า (ถ้ามี) : '
          },
          {
            fieldName: 'rem_request',
            caption: 'เหตุผลในการขอซื้อ : '
          },
          {
            fieldName: 'rem_dep',
            caption: 'คิดค่าใช้จ่ายแผนก/ฝ่าย : '
          },
          {
            fieldName: 'rem_use',
            caption: 'เพื่อใช้งาน'
          },
          {
            fieldName: 'EmpCode',
            caption: 'ผู้รับผิดชอบงาน'
          },
          // {fieldName: 'committee_1', caption: 'ขอแต่งตั้งให้'},
          // {fieldName: 'committee_2', caption: 'ขอแต่งตั้งให้'}
        ]
        for (let i = 0; i < atext.length; i++) {
          this.nextLine(doc, 5)
          ctext = atext[i].caption
  
          switch (atext[i].fieldName) {
            case '':
              vtext = ''
              break
            case 'rem_dep':
              vtext = this.$options.filters.depName(
                this.pdfdata_local[atext[i].fieldName],
                this.allDep
              )
              break
            case 'EmpCode':
            case 'committee_1':
            case 'committee_2':
              vtext = this.$options.filters.empName(
                this.pdfdata_local[atext[i].fieldName],
                this.empAll,
                'คุณ'
              )
              break
            default:
              vtext = this.pdfdata_local[atext[i].fieldName]
              break
          }
          // console.log(i, atext[i].fieldName + ' | ' + vtext)
          // let splitTitle = doc.splitTextToSize(text, 10);
          // lx = doc.getTextWidth(text) + marginText
          let lineRight = this.pRight // ตำแหน่งขวาสุดของเเส้นประ
          pp = this.setText(doc, ctext, tx, this.cLine, 'left')
          this.setLine(doc, pp.x - 1, this.cLine, 0, lineRight)
          this.setFontStyle(doc, 'bold')
          pp = this.setDBText(doc, vtext, pp.x + 2, this.cLine, 'left')
          this.setFontStyle(doc, 'normal')
        }
        // atext = [
        //   'เป็นคณะกรรมการ/คณะกรรมการตรวจรับ',
        //   'เป็นคณะกรรมการ/คณะกรรมการคัดเลือก'
        // ]
        // // this.nextLine(doc, 5)
        // tx = 110
        // for (let i = 0; i < atext.length; i++) {
        //   ctext = atext[i]
        //   this.setText(doc, ctext, tx, this.cLine, 'left')
        //   this.nextLine(doc, -5)
        // }
        // return ty + 5
      },
      wDetail01_1_committee(doc, ystart) {
        this.setNormalFont(doc)
        doc.setFontSize(12)
        // let ty = ystart + 5
        // this.nextLine(5)
        let tx = this.pLeft
        let pp
        let lx = 0
        let marginText = 6
        let ctext = ''
        let postfixtext = ''
        let vtext = ''
        // this.nextLine(-6)
        let atext = [{
            fieldName: 'committee_1',
            caption: 'ขอแต่งตั้งให้',
            postfix: 'เป็นคณะกรรมการ/คณะกรรมการคัดเลือก'
          },
          {
            fieldName: 'committee_2',
            caption: 'ขอแต่งตั้งให้',
            postfix: 'เป็นคณะกรรมการ/คณะกรรมการตรวจรับ'
          }
        ]
        for (let i = 0; i < atext.length; i++) {
          this.nextLine(doc, 5)
          ctext = atext[i].caption
          postfixtext = atext[i].postfix
  
          vtext = this.$options.filters.empName(
            this.pdfdata_local[atext[i].fieldName],
            this.empAll,
            'คุณ'
          )
          let lineRight = 140 // ตำแหน่งขวาสุดของเเส้นประ
          pp = this.setText(doc, ctext, tx, this.cLine, 'left')
          this.setLine(doc, pp.x, this.cLine, 0, lineRight)
          this.setText(doc, postfixtext, lineRight, this.cLine, 'left')
          this.setFontStyle(doc, 'bold')
          pp = this.setDBText(doc, vtext, pp.x + 2, this.cLine, 'left')
          this.setFontStyle(doc, 'normal')
        }
      },
      wPrintTableHeader(doc, tStart, hTable) {
        this.cLine = tStart
        let hline = this.tableHeaderHeight
        let line_cap = 1
        let cWidth = 10
        let rx = this.pLeft - 5
        let ry = this.cLine
        let rw = cWidth
        let rh = hline
        let tx = rx + cWidth / 2
        let ty = ry + hline / 2 + line_cap
        // this.cLine = ry + rh - 2
        for (let i = 0; i < hTable.length; i++) {
          doc.setFontSize(hTable[i].fontSize)
          let splitCaption = doc.splitTextToSize(
            hTable[i].caption,
            hTable[i].width
          )
          doc.rect(rx, ry, hTable[i].width, rh, 'S')
          if (hTable[i].alignH === 'center') {
            tx = rx + hTable[i].width / 2
          } else if (hTable[i].alignD === 'right') {
            tx = rx + hTable[i].width - 1
          } else {
            tx = rx + 1
          }
          ty = ry + hline / 2 + line_cap
          this.setText(
            doc,
            splitCaption,
            tx,
            ty - (splitCaption.length - 1) * 3,
            hTable[i].alignH
          )
          rx += hTable[i].width
        }
        // this.setLinNumber(doc)
      },
      wPageNumber(doc) {
        let pageCount = doc.internal.getNumberOfPages()
  
        // doc.setFont('helvetica', 'italic')
        doc.setFontSize(10)
        this.setFontStyle(doc, 'normal')
        for (var i = 1; i <= pageCount; i++) {
          doc.setPage(i)
          this.setText(doc, 'หน้า ' + String(i) + ' / ' + String(pageCount), doc.internal.pageSize.width / 2, this.pBottom + 7, 'center')
          this.setText(doc, 'F-AD-01(01)', this.pRight, this.pBottom + 7, 'right')
        }
      },
      wTableEmp(doc, tStart) {
        let itemsEmp = [{
          [this.hTableEmp[0].name]: 1,
          [this.hTableEmp[1].name]: this.pdfdata_local[this.hTableEmp[1].name],
          [this.hTableEmp[2].name]: this.pdfdata_local[this.hTableEmp[2].name],
          [this.hTableEmp[3].name]: this.pdfdata_local[this.hTableEmp[3].name],
        }]
  
        this.wDetailTable(doc, tStart, this.hTableEmp, itemsEmp)
  
      },
      wDetailTable(doc, tStart, hTable, dataItem) {
        // รายการขอซื้อ
        // console.log(this.pdfdata)
        this.cLine = tStart
        this.setNormalFont(doc)
  
        let hline = 10 // line height
        let hline_header = this.tableHeaderHeight // header height ต้องเท่ากับ ดีืแะรนื 
        let line_cap = -1 // margin top line
        let cWidth = 10
        let cStart = 15
        let rx = this.pLeft - 5
        let ry = this.cLine
        let rw = cWidth
        let rh = hline
        let tx = rx + cWidth / 2
        let ty = ry + hline / 2 + line_cap
        let pp
        let addpage = false
        // print table header
        this.wPrintTableHeader(doc, this.cLine, hTable)
        // this.setLinNumber(doc)
        this.nextLine(doc, hline - 2)
        // this.setLinNumber(doc)
        // print detail
        ry += hline_header
        for (let idata = 0; idata < dataItem.length; idata++) {
          // ry += hline
          let dtitem = dataItem[idata]
          //find many line from text
          let tline = 1
          console.log('hTable', hTable)
          for (let i = 0; i < hTable.length; i++) {
            let dValue = dtitem[hTable[i].name]
            if (hTable[i].name === 'EmpCode') {
              console.log('hTable[i].name', hTable[i].name)
              dValue = this.$options.filters.empFullName(dValue, this.empAll, 'คุณ')
              console.log('hTable[i].name dValue', dValue)
              dtitem[hTable[i].name] = dValue
            }
            switch (hTable[i].type) {
              case 'AccountCode':
                dValue = this.accountCodeFilter(dValue)
                break
              case 'Qty':
                dValue = dValue.toLocaleString('th-TH', {
                  minimumFractionDigits: 0
                }) //+ ' ' + dtitem.unit
                // tline=2
                break
              case 't':
                if (dValue) {
                  dValue = this.dbtoString(dValue)
                } else {
                  dValue = ""
                }
                break
              case 'n0':
                dValue = dValue.toLocaleString('th-TH', {
                  minimumFractionDigits: 0
                })
                break
              case 'n2':
                dValue = dValue.toLocaleString('th-TH', {
                  minimumFractionDigits: 2
                })
                break
              case 'd':
                dValue = this.$options.filters.date(dValue)
                break
              default:
                if (dValue) {
                  dValue = this.dbtoString(dValue)
                } else {
                  dValue = ""
                }
                // code block
            }
            console.log('hTable[i].name after', hTable[i].name)
            console.log('hTable[i].name dValue after', dValue)
            let tline_temp = doc.splitTextToSize(dValue, hTable[i].width - 1)
            if (Array.isArray(tline_temp)) {
              if (tline_temp.length > tline) {
                tline = tline_temp.length
              }
            }
          }
          rh = (tline * 6.5) //ตั้งความสูงตามจำนวนบรรทัดสูงสุด
  
          // if(idata ===  0){
          //   ry += hline_header
          // } else {
          //   ry += rh
          //   // ry += this.cLine
          // }
          // this.setLinNumber(doc)
          // this.setText(doc, tline + '|rh:' + rh +'|ry' + ry + ' list:'+ dtitem.List,this.pRight,this.cLine , 'right')
          addpage = this.nextLine(doc, rh, rh)
          if (addpage) {
            this.wPrintTableHeader(doc, this.cLine, hTable)
            this.nextLine(doc, hline)
            ry = this.cLine
          } else {
            // this.nextLine(doc,-rh)
          }
          rx = this.pLeft - 5
  
          console.log('dtdata ' + idata, dtitem)
  
          console.log('rect ' + idata, 'rx:' + rx + ', ry:' + ry + ', rh:' + rh)
          // this.setLinNumber(doc)
  
          for (let i = 0; i < hTable.length; i++) {
            // console.log('data'+i, dtitem[hTable[i].name])
            let dValue = dtitem[hTable[i].name]
            if (hTable[i].name === 'List') {
              // console.log('hTable[i].name', hTable[i].name)
              dValue = idata + 1
              // console.log('hTable[i].name dValue', dValue)
            }
            switch (hTable[i].type) {
              case 'AccountCode':
                dValue = this.accountCodeFilter(dValue)
                break
              case 'Qty':
                dValue = dValue.toLocaleString('th-TH', {
                  minimumFractionDigits: 0
                }) + ' ' + dtitem.unit
                break
              case 't':
                dValue = this.dbtoString(dValue)
                break
              case 'n0':
                dValue = dValue.toLocaleString('th-TH', {
                  minimumFractionDigits: 0
                })
                break
              case 'n2':
                dValue = dValue.toLocaleString('th-TH', {
                  minimumFractionDigits: 2
                })
                break
              case 'd':
                dValue = this.$options.filters.date(dValue)
                break
              default:
                dValue = dValue.toString()
                // code block
            }
            // console.log(hTable[i].name ,hTable[i].width+' '+ dValue)
            let splitCaption = doc.splitTextToSize(dValue, hTable[i].width - 1)
            doc.setFontSize(hTable[i].fontSize)
  
            doc.rect(rx, ry, hTable[i].width, rh, 'S')
            if (hTable[i].alignD === 'center') {
              tx = rx + hTable[i].width / 2
            } else if (hTable[i].alignD === 'right') {
              tx = rx + hTable[i].width - 1
            } else {
              tx = rx + 1
            }
            ty = ry + (rh / 2)
            //find margin ty ตามจำนวนบรรทัด ถ้า 1 ไม่ต้องทำ
            let tyMargin = ((splitCaption.length - 1) * 2)
            if (splitCaption.length === 1) {
              tyMargin = -1.5
              // ty = ry + (rh / 2) - (tline*.05)
            }
  
            // this.setText(doc,splitCaption,tx,ty - ((splitCaption.length-1) * 3) , hTable[i].alignD)
            if (hTable[i].name === 'Qty') {
              this.setText(doc, splitCaption, tx, ty - tyMargin, hTable[i].alignD)
              // this.setText(doc,dtitem.unit,tx,ty + 2 , hTable[i].alignD)
            } else {
              this.setText(doc, splitCaption, tx, ty - tyMargin, hTable[i].alignD)
            }
            rx += hTable[i].width
          }
          if (addpage) {
            this.nextLine(doc, rh, rh + 10)
            console.log('nextLine', addpage)
            // this.nextLine(doc,rh,rh+10)
            // this.nextLine(doc,rh,rh+10)
            // if (ry === this.pTop){
            //   this.wPrintTableHeader(doc,this.cLine)
            //   this.nextLine(doc,hline)
            //   ry = this.cLine
            // }          
            // this.setText(doc,this.cLine+' ',this.pLeft-5,this.cLine,'right')
          }
          ry += rh
        }
        // let mxl = doc.getTextWidth(' ' + ETotal + ' บาท')
        // let mxr = doc.getTextWidth('บาท')
        // this.setLine(doc, this.pRight -mxl , this.cLine, 0,  this.pRight - mxr )
        // this.setText(doc,ETotal + ' บาท', this.pRight, this.cLine, 'right')
        // doc.text('บาท', tx + rw - 5, this.cLine, null, null, 'left')
        return
      },
      wTotal(doc) {
        doc.setFontSize(16)
        this.setFontStyle(doc, 'bold')
        // this.cLine = ty
        // let tx = 130
        // this.nextLine(doc, 12)
        let ETotal = this.pdfdata_local.ETotal
        if (ETotal) {
          ETotal = this.pdfdata_local.ETotal.toLocaleString('th-TH', {
            minimumFractionDigits: 2
          })
        } else {
          ETotal = "0.00"
        }
        this.setText(
          doc,
          'ราคารวม ทั้งสิ้น ' + ETotal + ' บาท',
          this.pRight,
          this.cLine,
          'right'
        )
      },
      wHeader(doc) {
        let ty = this.pTop + 5
        let img = new Image()
        img.src = process.env.VUE_APP_API_PATH + 'dist/img/logo_tai.jpg'
  
        try {
          // doc.addImage(img, 'png', this.pCenter - 20 , 15, 38, 12)
          // doc.Image(img, 'png', this.pTop , 15, 38, 12)
          // doc.addImage(img, 'png', this.pCenter - 25, this.pTop, 45, 14)
          // doc.addImage(img, 'png', this.pLeft, this.pCenterY + 5, 45, 14)
          doc.addImage(img, 'png', this.pLeft, 5, 38, 12)

        } catch (e) {
          console.log('sign emp not found')
        }
  
        doc.setFontSize(16)
        this.setFontStyle(doc, 'bold')
        // this.setText(doc, this.pageTitle, this.pCenter, ty, 'center')
        this.setText(doc, this.pageTitle,  115, 10, 'center')
        this.setText(doc, this.pageTitle_eng, 115, 16, 'center')
        doc.setDrawColor(0, 0, 0)
  
        //  เลขที่สมาชิก
        // this.cLine = this.pTop + 10
        // doc.setFontSize(14)
        // this.setFontStyle(doc, 'normal')
        // this.nextLine(doc, 8)
        // this.setText(
        //   doc,
        //   'เลขที่สมาชิก ...................................................',
        //   this.pRight,
        //   this.cLine,
        //   'right'
        // )
        // doc.setFontSize(16)
        // this.setDBText(doc, this.pdfdata_local.MemberCode, 180, this.cLine - 0.5, 'center')
        // this.setNormalFont(doc)
  
      },
      drawGrid(doc) {
        doc.setFont('THSarabunNew')
        doc.setFontSize(16)
        doc.setDrawColor(0, 0, 0)
        doc.setLineDashPattern([], 0)
        doc.setLineWidth(0.1)
        doc.setLineDashPattern([0.3, 0.3], 0.6)
        doc.setLineWidth(0.1)
        let x1 = 5,
          y1 = 10,
          x2 = 205,
          y2 = 290
        let xx, yy
        let i = 0
        // แนวนอน
        for (i = 0; i < 30; i++) {
          yy = i * 10
          doc.line(x1 - 3, yy, x2 + 3, yy, 'S')
          doc.text(i.toString(), x1 + 5, i * 10, null, null, 'right')
        }
        // แนวตั้ง
        for (i = 0; i < 25; i++) {
          xx = i * 10 + 0
          doc.line(xx, y1 - 5, xx, y2 + 5, 'S')
          doc.text(i.toString(), xx, y1, null, null, 'right')
        }
  
        doc.setFontSize(16)
        this.setFontStyle(doc, 'bold')
        doc.setDrawColor('#ff0000')
        doc.setTextColor('#ff0000')
        doc.text(
          'pLeft:' + this.pLeft.toString(),
          this.pLeft,
          100,
          null,
          null,
          'left'
        )
        doc.text(
          'pRight:' + this.pRight.toString(),
          this.pRight,
          100,
          null,
          null,
          'right'
        )
        doc.text(
          'pCenter:' + this.pCenter.toString(),
          this.pCenter,
          100,
          null,
          null,
          'center'
        )
  
        doc.text('pWidth:' + this.pWidth, this.pCenter, 110, null, null, 'center')
  
        doc.text('pTop:' + this.pTop, this.pLeft, this.pTop, null, null, 'left')
        doc.text(
          'pBottom:' + this.pBottom,
          this.pLeft,
          this.pBottom,
          null,
          null,
          'left'
        )
  
        doc.setLineWidth(0.5)
        doc.rect(this.pLeft, this.pTop, this.pWidth, this.pHeight, 'S')
        doc.setDrawColor('#000000')
        doc.setTextColor('#000000')
        doc.setLineWidth(0.1)
        this.setNormalFont(doc)
      },
      setTextCheck: function (doc, x, y) {
        let temp_FontSize = doc.getFontSize()
        let temp_TextColor = doc.getTextColor()
        // this.setFontStyle(doc,"normal");
        doc.setTextColor('#444')
        doc.setFont('Zapfdingbats')
        doc.setFontSize(16)
        doc.text('4', x + 0.5, y, null, null, 'left')
  
        doc.setFont('THSarabunNew')
        doc.setFontSize(temp_FontSize)
        doc.setTextColor(temp_TextColor)
      },
      accountCodeFilter(v) {
        let result = v.split(',')
        if (result.length > 1) {
          return result[1]
        }
        return v
      },
      drawDetailPart1(doc,vline) {
        try {

          let pdfdata = this.pdfdata_local
          let tab01 = 0
          let curleft = 0
          this.cLine = vline
          this.nextLine(doc,6)
          doc.setFontSize(13)
          this.setFontStyle(doc,'bold')
          curleft = this.setText(doc, "เลขที่กระทรวงพาณิชย์" , 10, 26, 'left' )        
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.TradeCode , 48, 26, 'left')         
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ประเภทสมาชิก" , 100, 26, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Member_Type , 130, 26, 'left' )
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ชื่อภาษาไทย" , 10, 32, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Member_Title + " " + pdfdata.Name_Com_th , 30, 32, 'left' )
          // this.setText(doc, pdfdata.Name_Com_th , 50, 32, 'left' )
          this.setFontStyle(doc,'bold')
          this.setText(doc, "ชื่ออังกฤษ" , 100, 32, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Name_Com_en , 130, 32, 'left' )


        } catch (e) {
          console.log('Error',e)
        }

      },

      drawDetailPart2(doc,vline) {
        try {

          let pdfdata = this.pdfdata_local
          let tab01 = 0
          let curleft = 0
          // this.cLine = vline
          this.nextLine(doc,7)
          doc.setFontSize(13)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "สถานที่ตั้ง(ภาษาไทย)" ,  10, 39, 'left' )
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "เลขที่", 10, 45, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.AddressNumber_th || "-", 18, 45 )
          this.setFontStyle(doc,'bold') 

          this.setText(doc, "หมู่" , 27, 45, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Moo_th || "-",  37, 45  )



          this.setFontStyle(doc,'bold') 
          this.setText(doc, "อาคาร/หมู่บ้าน" || "-", 44, 45, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Building_th || "-",  63, 45  )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ชั้น" || "-", 105, 45, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Floor || "-", 110, 45 )          
          this.setFontStyle(doc,'bold')           
          this.setText(doc, "ซอย" || "-", 117, 45, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Soi_th || "-", 125, 45 )            
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ถนน" || "-", 158, 45, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Road_th || "-", 167, 45, 'left' ) 
          
          
          this.nextLine(doc,7)

          this.setFontStyle(doc,'bold') 
          this.setText(doc, "แขวง/ตำบล" , 10, 51, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Tambon_th ,28, 51  )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "เขต/อำเภอ" , 90, 51, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Amphur_th ,107, 51 )
// เริ่ม
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "จังหวัด" , 10, 57, 'left' )
          this.setFontStyle(doc,'normal')
          doc.setFontSize(13);
          this.setText(doc, pdfdata.Province_th ,24, 57  )
          doc.setFontSize(13);
          this.setFontStyle(doc,'bold')
          this.setText(doc, "รหัสไปรษณีย์" , 70, 57, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Zipcode , 88, 57 )        
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "นิคมอุตสหกรรม" || "-", 100, 57, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Industrial_estate_th || "-", 124, 57 )

          // สถานที่ตั้งภาษาอังกฤษ
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "สถานที่ตั้ง(ภาษาอังกฤษ)" , 10, 64, 'left' )
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "No." , 10, 70, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.AddressNumber_en , 16, 70 )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Moo" , 32, 70, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Moo_en || "-",  39, 70  )
          // if (pdfdata.Moo_en) {
          //     this.setText(doc, pdfdata.Moo_en , 32, 70 );
          //   } else {
          //     this.setText(doc, "-", 32, 70); // Display "-" when no data is available
          // }          
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Building" , 44, 70, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Building_en || "-",  63, 70 )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Floor" , 105, 70, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Floor || "-", 114, 70 )          
          this.setFontStyle(doc,'bold')           
          this.setText(doc, "Soi" , 117, 70, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Soi_en || "-", 124, 70 )          
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Road" , 158, 70, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Road_en || "-", 167, 70 )

          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Sub-District" , 10, 76, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Tambon_en , 29, 76 )          
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "District" , 90, 76, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Amphur_en , 107, 76 )
          // เริ่ม
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Province" , 10, 82, 'left' )
          this.setFontStyle(doc,'normal')
          doc.setFontSize(13);
          this.setText(doc, pdfdata.Province_en , 24,82 )
          doc.setFontSize(13);
          this.setFontStyle(doc,'bold')
          this.setText(doc, "Post code" , 70,82, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Zipcode , 88,82 )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Industrial Estate" , 100,82, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Industrial_estate_en || "-", 124,82 )
         
         
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "โทรศัพท์/Tel" , 10, 88, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Tel , 29, 88 )
          // this.setText(doc, "......................................" , 29, 93 )   Test dot field
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "เบอร์ต่อ" , 58, 88, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Ext || "-", 72, 88 )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Email" , 87, 88, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Email , 100, 88 )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "Website" , 140, 88, 'left' )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Website || "-", 154, 88 )
          this.setFontStyle(doc,'normal')

        } catch (e) {
          console.log('Error',e)
        }

      },

      drawDetailPart3(doc,vline) {
        try {

          let pdfdata = this.pdfdata_local
          let tab01 = 0
          let curleft = 0
          // this.cLine = vline
          // ส่วนที่ 3 ติดต่อประสานงาน
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          doc.setFontSize(14)
          doc.setTextColor("0A23D3");
          // this.setText(doc, "บุคคลผู้สามารถติดต่อประสานงานได้" , this.pLeft, this.cLine, 'left' )
          this.setText(doc, "บุคคลผู้สามารถติดต่อประสานงานได้" , 10, 96 )
          this.nextLine(doc,8)

          doc.setFontSize(13)
          doc.setTextColor("black");
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ผู้บริหารระดับสูง (*จำเป็น)" , 10, 103)
          // this.setText(doc, "ผู้บริหารระดับสูง (*จำเป็น)" , this.pLeft, this.cLine, 'left' )
        
          this.nextLine(doc,7)
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.TitleName_th0 , 12, 110  ) //0
          this.setText(doc, pdfdata.Name_th0 , 21, 110  )//0
          this.setText(doc, pdfdata.LastName_th0 , 40, 110 )//0
          this.setText(doc, "ตำแหน่ง" , 90, 110 )//0
          this.setText(doc, pdfdata.Position_th0 , 105, 110 )//0
          this.nextLine(doc,7)
          this.setText(doc, pdfdata.TitleName_en0 , 12, 117 )//0
          this.setText(doc, pdfdata.Name_en0 , 21, 117 )//0
          this.setText(doc, pdfdata.LastName_en0 , 40, 117 )//0
          this.setText(doc, "Position" , 90, 117  )//0
          this.setText(doc, pdfdata.Position_en0 , 105, 117 )//0
          this.nextLine(doc,7)
          this.setText(doc, "Email" , 12, 124 )
          this.setText(doc, pdfdata.Email0 , 21, 124 )//0
          this.setText(doc, "โทรศัพท์" , 90, 124 )//0
          this.setText(doc, pdfdata.Tel0 , 105, 124 )//0
          this.setText(doc, "เบอร์ต่อ" , 135, 124 )//0
          this.setText(doc, pdfdata.Ext_number0 || "-", 150, 124 )//0

          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ผู้ประสานงาน ลำดับที่ 1" , 10, 132 )
          this.nextLine(doc,7)
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.TitleName_th1 , 12, 139  ) //1
          this.setText(doc, pdfdata.Name_th1 , 21, 139  )//1
          this.setText(doc, pdfdata.LastName_th1 , 40, 139 )//1
          this.setText(doc, "ตำแหน่ง" , 90, 139 )//1
          this.setText(doc, pdfdata.Position_th1 , 105, 139 )//1
          this.nextLine(doc,7)
          this.setText(doc, pdfdata.TitleName_en1 , 12, 146 )//1
          this.setText(doc, pdfdata.Name_en1 , 21, 146 )//1
          this.setText(doc, pdfdata.LastName_en1 , 40, 146 )//1
          this.setText(doc, "Position" , 90, 146  )//1
          this.setText(doc, pdfdata.Position_en_1 , 105, 146 )//1
          this.nextLine(doc,7)
          this.setText(doc, "Email" , 12, 153 )
          this.setText(doc, pdfdata.Email1 , 21, 153 )//1
          this.setText(doc, "โทรศัพท์" , 90, 153 )//1
          this.setText(doc, pdfdata.Tel1 , 105, 153 )//1
          this.setText(doc, "เบอร์ต่อ" , 135, 153 )//1
          this.setText(doc, pdfdata.Ext_number1 || "-", 150, 153 )//1


          this.nextLine(doc,15)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ผู้ประสานงาน ลำดับที่ 2" , 10, 161 )//2
          this.nextLine(doc,7)
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.TitleName_th2 || "-" , 12, 168  ) //2
          this.setText(doc, pdfdata.Name_th2 || "-" , 21, 168  )//2
          this.setText(doc, pdfdata.LastName_th2 || "-" , 40, 168 )//2
          this.setText(doc, "ตำแหน่ง" , 90, 168 )//2
          this.setText(doc, pdfdata.Position_th2 || "-" , 105, 168 )//2
          this.nextLine(doc,7)
          this.setText(doc, pdfdata.TitleName_en2 || "-" , 12, 175 )//2
          this.setText(doc, pdfdata.Name_en2 || "-" , 21, 175 )//2
          this.setText(doc, pdfdata.LastName_en2 || "-" , 40, 175 )//2
          this.setText(doc, "Position" , 90, 175  )//2
          this.setText(doc, pdfdata.Position_en_2 || "-" , 105, 175 )//2
          this.nextLine(doc,7)
          this.setText(doc, "Email" , 12, 182 )//2
          this.setText(doc, pdfdata.Email2 || "-" , 21, 182 )//2
          this.setText(doc, "โทรศัพท์" , 90, 182 )//2
          this.setText(doc, pdfdata.Tel2 || "-" , 105, 182 )//2
          this.setText(doc, "เบอร์ต่อ" , 135, 182 )//2
          this.setText(doc, pdfdata.Ext_number2 || "-", 150, 182 )//2


          this.nextLine(doc,15)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ผู้ประสานงาน ลำดับที่ 3" , 10, 190 )//3
          this.nextLine(doc,7)
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.TitleName_th3 || "-" , 12, 197  ) //3
          this.setText(doc, pdfdata.Name_th3 || "-" , 21, 197  )//3
          this.setText(doc, pdfdata.LastName_th3 || "-" , 40, 197 )//3
          this.setText(doc, "ตำแหน่ง" , 90, 197 )//3
          this.setText(doc, pdfdata.Position_th3 || "-" , 105, 197 )//3
          this.nextLine(doc,7)
          this.setText(doc, pdfdata.TitleName_en3 || "-" , 12, 204 )//3
          this.setText(doc, pdfdata.Name_en3 || "-" , 21, 204 )//3
          this.setText(doc, pdfdata.LastName_en3 || "-" , 40, 204 )//3
          this.setText(doc, "Position" , 90, 204  )//3
          this.setText(doc, pdfdata.Position_en_3 || "-" , 105, 204 )//3
          this.nextLine(doc,7)
          this.setText(doc, "Email" , 12, 211 )//2
          this.setText(doc, pdfdata.Email3 || "-" , 21, 211 )//3
          this.setText(doc, "โทรศัพท์" , 90, 211 )//3
          this.setText(doc, pdfdata.Tel3 || "-" , 105, 211 )//3
          this.setText(doc, "เบอร์ต่อ" , 135, 211 )//3
          this.setText(doc, pdfdata.Ext_number3 || "-", 150, 211 )//3
          // this.nextLine(doc,7)
          // this.setFontStyle(doc,'normal')
          // this.setText(doc, pdfdata.TitleName_th2 || "-", 10, 153 ) //2
          // this.setText(doc, pdfdata.TitleName_th3 || "-", 110, 153 ) //3

          // this.setText(doc, pdfdata.Name_th2 || "-", 21, 153 )//2
          // this.setText(doc, pdfdata.Name_th3 || "-", 121, 153 )//3

          // this.setText(doc, pdfdata.LastName_th2 || "-", 40, 153 )//2
          // this.setText(doc, pdfdata.LastName_th3 || "-", 140, 153 )//3

          // this.setText(doc, "ตำแหน่ง" , 60, 153 )//2
          // this.setText(doc, "ตำแหน่ง" , 160, 153 )//3

          // this.setText(doc, pdfdata.Position_th2 || "-", 75, 153 )//2
          // this.setText(doc, pdfdata.Position_th3 || "-", 175, 153 )//3

          // this.nextLine(doc,7)
          // this.setText(doc, pdfdata.TitleName_en2 || "-", 10, 160 )//2
          // this.setText(doc, pdfdata.TitleName_en3 || "-", 110, 160 )//3

          // this.setText(doc, pdfdata.Name_en2 || "-", 21, 160 )//2
          // this.setText(doc, pdfdata.Name_en3 || "-", 128, 160 )//3

          // this.setText(doc, pdfdata.LastName_en2 || "-", 40, 160 )//2
          // this.setText(doc, pdfdata.LastName_en3 || "-", 140, 160 )//3

          // this.setText(doc, "Position" , 60, 160 )//2
          // this.setText(doc, "Position" , 160, 160  )//3

          // this.setText(doc, pdfdata.Position_en_2 || "-", 75, 160 )//2
          // this.setText(doc, pdfdata.Position_en_3 || "-", 175, 160 )//2

          // this.nextLine(doc,7)
          // this.setText(doc, pdfdata.Email2 || "-", 10, 167 )//2
          // this.setText(doc, pdfdata.Email3 || "-", 110, 167  )//3

          // this.setText(doc, "โทรศัพท์" , 50, 167 )//2
          // this.setText(doc, "โทรศัพท์" , 150, 167 )//3

          // this.setText(doc, pdfdata.Tel2 || "-", 62, 167 )//2
          // this.setText(doc, pdfdata.Tel3 || "-", 162, 167 )//3


          // this.setText(doc, "เบอร์ต่อ" , 82, 167 )//2
          // this.setText(doc, "เบอร์ต่อ" , 182, 167 )//3

          // this.setText(doc, pdfdata.Ext_number2 || "-", 93, 167 )//2
          // this.setText(doc, pdfdata.Ext_number3 || "-", 193, 167 )//3

        } catch (e) {
          console.log('Error',e)
        }

      },

      drawDetailPart4(doc,vline) {
        try {

          let pdfdata = this.pdfdata_local;
          let tab01 = 0;
          let curleft = 0;
          // this.cLine = vline
          // Format the Staff count with commas
          let formattedStaffCount = pdfdata.Staff.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); //ใส่ comma ให้ข้อมูลที่เป็นตัวเลข
          let formattedRegister_capitalCount = pdfdata.Register_capital.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); //ใส่ comma ให้ข้อมูลที่เป็นตัวเลข
          let formattedPaid_capitalCount = pdfdata.Paid_capital.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); //ใส่ comma ให้ข้อมูลที่เป็นตัวเลข
          // ส่วนที่ 4 ข้อมูลบริษัท
          this.nextLine(doc,15)
          doc.setTextColor("0A23D3");
          this.setFontStyle(doc,'bold') 
          // doc.setFontSize(18)
          this.setText(doc, "ข้อมูลบริษัท" , 10, 218 )
          this.nextLine(doc,7)
          doc.setTextColor("black");
          this.setText(doc, "สัดส่วนผู้ถือหุ้น" , 10, 224 )
          this.setFontStyle(doc,'normal')
          this.setText(doc, "ไทย " + pdfdata.Share_thai + "%" , 35, 224  )
          this.setText(doc, "ต่างชาติ " + pdfdata.Share_foreign +"%" , 55, 224 )
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "สัญชาติของผู้ถือหุ้นใหญ่" , 78, 224 )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Nationshare , 112, 224 )
          this.setFontStyle(doc, 'bold');
          this.setText(doc, "ชื่อบริษัทต้นสังกัด" , 128, 224 )
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Original_com ,  153, 224 )

          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ประเภทอุตสาหกรรม" , 10, 230 )
          this.nextLine(doc,7)
          this.setFontStyle(doc,'normal')  
          doc.setFontSize(13)        
          this.setText(doc, pdfdata.Business_Title + "   " +"( " + pdfdata.Tier_Title + " )" , 10, 236 )

          doc.setFontSize(13)  
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "อุตสาหกรรมเกี่ยวเนื่อง" , 10, 242 )
          this.setFontStyle(doc,'normal')  
          doc.setFontSize(13)         
          this.setText(doc, pdfdata.Related_industry + "   " +""  , 45, 242 )


          doc.setFontSize(13)
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold')          
          this.setText(doc, "อุตสาหกรรมเกี่ยวเนื่องอื่นๆ (ระบุ)" , 10, 248 )
          doc.setFontSize(13)         
          this.setFontStyle(doc,'normal')  
          this.setText(doc, pdfdata.Related_other || "-", 55, 248 )

          doc.setFontSize(13)
          this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          // this.nextLine(doc,7)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "ขนาดของกิจการ :" , 10, 253 )
          this.setFontStyle(doc,'normal')
          this.setText(doc, "จำนวนบุคลากรทั้งหมด " + formattedStaffCount + ' คน ' +   " ทุนจดทะเบียน " + formattedRegister_capitalCount + ' ล้านบาท ' +   " ทุนชำระแล้ว " + formattedPaid_capitalCount + ' ล้านบาท ' , 35, 253);
          this.setFontStyle(doc,'bold')
          this.setText(doc, "กิจกรรมของสถาบันยานยนต์ที่ท่านสนใจ" , 10, 259 )
          doc.setFontSize(13)
          this.setFontStyle(doc,'normal')
          this.setText(doc, pdfdata.Tai_activity + "   " +""  , 10, 265 )     

          // this.nextLine(doc,7)
          doc.setFontSize(13)
          this.setFontStyle(doc,'bold') 
          this.setText(doc, "อื่นๆ(ระบุ)" , 10, 271 )
          
          // this.nextLine(doc,7)
          
          this.setFontStyle(doc,'normal');         
          this.setText(doc, pdfdata.Tai_activity_other || "-", 30, 271 )

          // doc.setFontSize(12)
          // doc.setTextColor("D50F4B");
          // this.setFontStyle(doc,'bold')
          // this.setText(doc, "ขอยืนยันว่าข้อมูลดังกล่าวเป็นความจริงทุกประการ ได้รับการอนุญาตในการสมัครสมาชิกสถาบันยานยนต์ จากหน่วยงานโดยผู้บริหารสูงสุด (รายชื่ออันดับที่ 1) แล้ว" , 10, 289 )
          // this.setText(doc, "กรณีมีการเปลี่ยนแปลงที่อยู่ กรุณาแจ้งกลับสถาบันยานยนต์ เพื่อใช้ในการปรับปรุงฐานข้อมูลให้เป็นปัจจุบัน (ดาวน์โหลดเอกสาร)" , 10, 294 )

        } catch (e) {
          console.log('Error',e)
        }

      },

      // start box ผู้ประสานงาน

      drawStamp(doc,vline) {
          try {
                let startX = this.pLeft + 5
                doc.setLineDashPattern([0, 0], 1);
                // doc.line(this.pLeft, (this.pHeight/2), this.pRight, (this.pHeight/2), 'DF')
                let boxX = 7
                  ,boxY = 98
                  ,boxW = 196
                  ,boxH = 28
                doc.rect(boxX, boxY , boxW, boxH, )//upleft
                  boxX = 7  
                  boxY= 127
                  boxW = 196
                  boxH = 28
                doc.rect(boxX, boxY , boxW, boxH, 'S')//buttomleft
                  boxX = 7  
                  boxY= 156
                  boxW = 196
                  boxH = 28
                doc.rect(boxX, boxY , boxW, boxH, 'S')//buttomleft
                  boxX = 7  
                  boxY= 185
                  boxW = 196
                  boxH = 28
                doc.rect(boxX, boxY , boxW, boxH, 'S')//buttomleft

          } catch (e) {
          console.log('Error',e)
          }
      },
      // drawStamp(doc,vline) {

      //     try {

      //           let startX = this.pLeft + 5
      //           doc.setLineDashPattern([0, 0], 1);
      //           // doc.line(this.pLeft, (this.pHeight/2), this.pRight, (this.pHeight/2), 'DF')
      //           let boxX = 5
      //             ,boxY = 103
      //             ,boxW = 98
      //             ,boxH = 35
      //           doc.rect(boxX, boxY , boxW, boxH, )//upleft
      //             boxX = 5  
      //             boxY+=37
      //             boxW = 98
      //             boxH = 35
      //           doc.rect(boxX, boxY , boxW, boxH, 'S')//buttomleft
      //             boxX = 105  
      //             boxY = 103
      //             boxW = 98
      //             boxH = 35
      //           doc.rect(boxX, boxY , boxW, boxH, 'S')//upright
      //             boxX = 105  
      //             boxY+=37
      //             boxW = 98
      //             boxH = 35
      //           doc.rect(boxX, boxY , boxW, boxH, 'S')//buttomright
      //     } catch (e) {
      //     console.log('Error',e)
      //     }
      // },


// end test



    wFooter(doc){

      let ty = this.pTop + 5
      let img = new Image()
      img.src = process.env.VUE_APP_API_PATH + 'dist/img/taimember.png'

      try {
        doc.addImage(img, 'png', this.pRight -15 , 270, 20, 20)
      } catch (e) {
        console.log('sign emp not found')
      }



      let pdfdata = this.pdfdata_local
      let boxX = this.pLeft-6
      let boxW = this.pWidth+8
      let boxH = 13
      let boxY = this.pBottom - boxH
      doc.rect(boxX, boxY-3, boxW - boxH -5 , boxH, 'S');
      // doc.rect(boxX, boxY, boxW - boxH -5 , boxH, 'S'); //อันเดิม
      // doc.addImage(pdfdata.qrToken, 'png', this.pRight-boxH, boxY , boxH, boxH)
      doc.rect(this.pRight-boxH-2 , 270, 20, 20, 'S');
      this.cLine = boxY+2
      doc.setTextColor("D50F4B");
      this.setFontStyle(doc,'bold')
      doc.setFontSize(11)
      this.setText(doc, '*ขอยืนยันว่าข้อมูลดังกล่าวเป็นความจริงทุกประการ ได้รับการอนุญาตในการสมัครสมาชิกสถาบันยานยนต์ จากหน่วยงานโดยผู้บริหารสูงสุด (รายชื่ออันดับที่ 1) แล้ว', 7, 282  )
      // this.setText(doc, '*ขอยืนยันว่าข้อมูลดังกล่าวเป็นความจริงทุกประการ ได้รับการอนุญาตในการสมัครสมาชิกสถาบันยานยนต์ จากหน่วยงานโดยผู้บริหารสูงสุด (รายชื่ออันดับที่ 1) แล้ว', this.pLeft - (boxH/2), this.cLine , 'left' )
      this.nextLine(doc,5)
      this.setText(doc, '**กรณีมีการเปลี่ยนแปลงที่อยู่ กรุณาแจ้งกลับสถาบันยานยนต์ เพื่อใช้ในการปรับปรุงฐานข้อมูลให้เป็นปัจจุบัน (ดาวน์โหลดเอกสาร)', 7, 287   );
      // this.setText(doc, '**กรณีมีการเปลี่ยนแปลงที่อยู่ กรุณาแจ้งกลับสถาบันยานยนต์ เพื่อใช้ในการปรับปรุงฐานข้อมูลให้เป็นปัจจุบัน (ดาวน์โหลดเอกสาร)', this.pLeft - (boxH/2), this.cLine , 'left' );
      doc.setFontSize(10)          
      doc.setTextColor("000000");
      this.nextLine(doc,8)
      this.setText(doc, 'F-MC-02(01)-Rev01_30/08/65', 173, 294);
      // this.setText(doc, 'F-MC-02(01)-Rev01_30/08/65', this.pRight - (boxH/2) ,this.cLine , 'center');
      // this.setText(doc, 'โดยระบุ name Username: ' + pdfdata.username + ' password: ' + pdfdata.userpassword , this.pCenter -boxH,this.cLine , 'center');

    },

      savePDF() {
        console.log('savePDF', this.pdfdocument)
        this.pdfdocument.save(this.pdfFileName)
      },
      async downloadPDF(pdfdata) {
        this.loading = true
        this.dialog = true
        this.pdfdata_local = pdfdata
        this.$emit('beforePDF', pdfdata)

        console.log('downloadPDF',pdfdata)
  
        let addData = 15
        let data_temp
        let ranNum
        // for(let idata = 0 ; idata<addData;idata++){
        //   ranNum = (Math.floor(Math.random() * 2) + 1) -1
        //   data_temp = JSON.stringify(this.pdfdata_local.DTdata[ranNum])
        //   let temp = JSON.parse(data_temp)
        //   temp.List = this.pdfdata_local.DTdata.length + 1
        //   this.pdfdata_local.DTdata.push(temp)
        // }
  
        // console.log('downloadPdf before getDB',this.pdfdata)
        //   this.pdfdata_local = await this.getDB(pdfdata.ID)
        // console.log('downloadPdf After getDB',this.pdfdata)
  
        // this.pdfdata_local.DocCode = 'IT-64/0001'
        // this.pdfdata_local.EmpDate06 = null
  
        let doc = new JsPdf('portrait', 'mm', 'a4')
        // console.log('PDF data', this.pdfdata)
        doc.setLanguage('th-TH')
        let fonts = this.$store.getters.fonts
        let i = 0
        for (i = 0; i < fonts.length; i++) {
          doc.addFileToVFS(fonts[i].nametype, fonts[i].img)
        }
        i = 0
        for (i = 0; i < fonts.length; i++) {
          try {
            doc.addFont(fonts[i].nametype, fonts[i].name, fonts[i].style)
          } catch (e) {
            console.log(e)
          }
        }
        // doc.addFont('THSarabunNew.ttf', 'THSarabunNew', 'normal')
        // doc.addFont('THSarabunNewB.ttf', 'THSarabunNew', 'bold')
        // doc.addFont('THSarabunNewI.ttf', 'THSarabunNew', 'italic')
        // doc.addFont('THSarabunNewBI.ttf', 'THSarabunNew', 'bolditalic')
        let vline = 30
        let hline = 5.5
        
  
        doc.setFont('THSarabunNew')
        doc.setFontSize(16)
        /** WITH CSS */
        this.pageTitle = 'ใบสมัครสมาชิก​ สถาบันยานยนต์​ (สำหรับนิติบุคคล)'
        this.pageTitle_eng = 'Application Form for Membership of TAI (Juristic Persons)'
        //   if (this.pdfdata_local.DocTypeCode.indexOf('AS') === 0) {
        //     this.pageTitle = 'ใบขออนุมัติซื้อสินทรัพย์ถาวร'
        //   }
        // alert(this.pageTitle)
        // this.drawGrid(doc)
  
        this.wHeader(doc)
        
      
        this.drawDetailPart1(doc,vline)   
  
        this.drawDetailPart2(doc,vline) 

        this.drawDetailPart3(doc,vline) 

        this.drawDetailPart4(doc,vline) 

        this.drawStamp(doc,vline) 

        this.wFooter(doc)
  
        //======================================================
        // preview
        //======================================================
        let optionsPDFObject = {
          pdfOpenParams: {
            view: 'FitV',
            pagemode: 'thumbs'
          },
          width: "100%",
          height: "80vh"
        }
  
        optionsPDFObject = {
          pdfOpenParams: {
            // navpanes: 0,
            // toolbar: 0,
            // statusbar: 0,
            // page: 2
            // pagemode: "thumbs",
            view: "FitV",
          },
          forcePDFJS: true,
          PDFJS_URL: this.pdfviewerURL
        };
  
        // let pdfOutput = await doc.output('datauristring')
        // PDFObject.embed(pdfOutput, '#pdfPreview', optionsPDFObject)
  
        let blob = await doc.output('blob')
        const pdfTempURL = URL.createObjectURL(blob)
        
        PDFObject.embed(pdfTempURL, '#pdfPreview', optionsPDFObject)
  
        this.loading = false
  
        // this.pdfdocument = doc
        // this.pdfFileName = this.pdfdata_local.DocCode.replace('/', '') + '.pdf'  // ลบเรียกไฟล์เดิมออำ
  
        return this.pdfdata
      }
    }
  }
  </script>
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  
  <style scoped>
  #pdfPreview {
    height: 94vh;
  }
  </style>
  